import {
  REMOVE_ACTIVE_LAYER,
  SET_ACTIVE_LAYER_VISIBLE,
  REORDER_ACTIVE_LAYERS,
  SET_OR_CREATE_NEW_ACTIVE_LAYER,
  SET_OR_CREATE_NEW_ACTIVE_LAYERS,
  SET_ACTIVE_LAYER_STYLING,
  SET_ACTIVE_LAYER_PRINTABLE,
  SET_ALL_ACTIVE_LAYERS_PRINTABLE,
  HIDE_ACTIVE_LAYERS,
  REMOVE_ALL_LAYERS
} from './Types';
import { IActiveLayerAction, IActiveLayerReducerState } from './activeLayerTypes';
import {
  setActiveLayer,
  setActiveLayers,
  setActiveLayerStyling
} from './helpers/setActiveLayer';

/*
 * activeLayer should look like:
 * {
 *   uid: string, // unique id of the layer
 *   systemName: string, // system name of the layer
 *   visible: boolean,
 *   printable: boolean
 * }
 * Two filters for the print map and regular map
 */

function reorderActiveLayer(
  state: IActiveLayerReducerState,
  action: IActiveLayerAction
) {
  return [...action.reorderedLayers];
}

function setActiveLayerVisible(
  state: IActiveLayerReducerState,
  action: IActiveLayerAction
) {
  return [
    ...state.map(layer => {
      if (layer.uid === action.uid) {
        return {
          ...layer,
          visible: action.isVisible
        };
      } else {
        return layer;
      }
    })
  ];
}

function setHideActiveLayers(
  state:IActiveLayerReducerState,
  action: IActiveLayerAction
) {
  return state.map((layer) => layer.visible === true ? { ...layer, visible: false } : layer);     
}

function setActiveLayerPrintable(
  state: IActiveLayerReducerState,
  action: IActiveLayerAction
) {
  const layerIdx = state.findIndex(l => l.uid === action.uid);
  let editableState = [...state];
  editableState.splice(layerIdx, 1, {
    ...state[layerIdx],
    printable: action.printable
  });
  return [...editableState];
}

function setAllActiveLayersPrintable(
  state: IActiveLayerReducerState,
  action: IActiveLayerAction
) {
  const newState = state.map(l => ({ ...l, printable: action.value }));
  return newState;
}

export default function reducer(
  state: IActiveLayerReducerState = [],
  action: IActiveLayerAction
) {
  switch (action.type) {
    case REMOVE_ACTIVE_LAYER:
      return [...state.filter(l => l.uid !== action.uid)];
    case SET_ACTIVE_LAYER_VISIBLE:
      // If layer exists, edit existing layer. Else, add the new layer.
      return setActiveLayerVisible(state, action);
    case REORDER_ACTIVE_LAYERS:
      return reorderActiveLayer(state, action);
    case SET_OR_CREATE_NEW_ACTIVE_LAYER:
      return setActiveLayer(state, action);
    case SET_OR_CREATE_NEW_ACTIVE_LAYERS:
      return setActiveLayers(state, action);
    case SET_ACTIVE_LAYER_PRINTABLE:
      return setActiveLayerPrintable(state, action);
    case SET_ALL_ACTIVE_LAYERS_PRINTABLE:
      return setAllActiveLayersPrintable(state, action);
    case HIDE_ACTIVE_LAYERS:            
      return setHideActiveLayers(state, action)
    case REMOVE_ALL_LAYERS:
      return []
    default:
      return state;
  }
}
